import { BaseElement } from './base-element.model';
import { Base } from './report-editor.model';

export class BaseTemplateElement extends BaseElement {
    visible = true;
    isDuplicated?: boolean;

    constructor(base: Base) {
        super(base);
    }
}
